import { Button } from "@/components/ui/button";
import FilloutButton from "@/components/FilloutButton";
import { ArrowRight, Phone, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from 'react-router-dom';
import { generateLocalizedUrl } from "@/lib/slugUtils";
import { supportedLanguages, type SupportedLanguage } from "@/lib/i18n";

const CTASection = () => {
  const { t } = useTranslation('misc');
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: SupportedLanguage }>();
  const currentLang = lang && supportedLanguages.includes(lang) ? lang : 'en';

  const handleScheduleConsultation = () => {
    const contactUrl = generateLocalizedUrl('contact', currentLang);
    navigate(contactUrl);
  };

  return (
    <section id="contact" className="py-20 bg-gradient-hero">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-foreground mb-6">
            {t('cta.title')}
          </h2>
          
          <p className="text-xl text-primary-foreground/90 mb-12 max-w-2xl mx-auto">
            {t('cta.description')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <FilloutButton size="lg" variant="secondary" className="text-lg px-8 py-3 group">
              {t('cta.primaryButton')}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </FilloutButton>
            
            <Button size="lg" variant="gradient-outline" className="text-lg px-8 py-3" onClick={handleScheduleConsultation}>
              {t('cta.secondaryButton')}
            </Button>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
            <div className="flex items-center justify-center space-x-3 text-primary-foreground/80">
              <Phone className="w-5 h-5" />
              <span>{t('cta.features.0')}</span>
            </div>
            <div className="flex items-center justify-center space-x-3 text-primary-foreground/80">
              <Mail className="w-5 h-5" />
              <span>{t('cta.features.1')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;